import { ContentSection as ContentSectionType } from '@/lib/gcc-content'

interface DifferentiatorsSplitSectionProps {
  section: ContentSectionType
  className?: string
}

const DifferentiatorsSplitSection = ({ section, className = '' }: DifferentiatorsSplitSectionProps) => {
  return (
    <section data-testid="differentiators" className={`py-24 px-4 sm:px-6 lg:px-8 bg-slate-50/50 ${className}`}>
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        {/* Sticky left column with title + subtitle/content */}
        <div className="lg:sticky lg:top-24 self-start lg:pr-12">
          <h2 className="text-3xl font-light text-slate-900 mb-4 lg:text-4xl tracking-tight">
            {section.title}
          </h2>
          {section.content && (
            <p className="text-xl text-slate-600 leading-relaxed font-light max-w-xl">
              {section.content}
            </p>
          )}
        </div>

        {/* Right column with stacked differentiators and a soft connector line */}
        <div className="relative lg:pl-6">
          {/* vertical connector line */}
          <div className="hidden sm:block absolute left-0 top-0 bottom-0 w-px bg-slate-200" />

          <div className="space-y-6 pl-8">
            {section.items?.map((item, index) => (
              <div key={index} className="relative bg-white/80 backdrop-blur-sm border border-slate-200 rounded-lg shadow-sm p-6">
                {/* node on the connector line */}
                <div className="hidden sm:block absolute -left-1.5 top-6 w-3 h-3 rounded-full bg-slate-400" />
                <span className="text-slate-700 leading-relaxed">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default DifferentiatorsSplitSection


